import React from "react";
import Fade from "react-reveal/Fade";

const Stats = ({items}) => {
  return (
    <section className='stats'>
     <Fade bottom distance='40px'>
       <div className="stats__inner">
         <div className='stats__items'>
           {
             items.length > 0 && items.map((el, i) => (
               <div key={i} className='stats__item'>
                 <h3>{el.value}</h3>
                 <p>{el.label}</p>
               </div>
             ))
           }
         </div>
       </div>
     </Fade>
    </section>
  )
}

export default Stats